import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

export const DisclosuresVisaMobile = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const [checked, setChecked] = useState(true);

  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_phone_step_01-visa-mobile${currentParams}`);
  };

  const styles = {
    telefono: {
      fontFamily: "Open Sans, sans-serif",
      marginTop: "30px",
      backgroundColor: "#f1f1f1",
      display: "flex",
      borderRadius: "50px",
      border: "15px solid #000000",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    container: {
      display: "flex",
      alignItems: "center",
      margin: "16px 0 8px 0",
      padding: "16px",
      height: "100%",
      boxSizing: "border-box",
    },
    arrow: {
      fontSize: "26px",
      marginLeft: "8px",
    },
    lines: {
      display: "flex",
      flexDirection: "column",
      marginRight: "8px",
    },
    lineBlue: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.primario,
      marginBottom: "4px",
    },
    lineYellow: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.secundario,
    },
    containerStep: {
      display: "flex",
      alignItems: "baseline",
      fontFamily: "sans-serif",
    },
    current: {
      color: colors.primario,
      fontSize: "40px",
      fontWeight: "bold",
    },
    separator: {
      margin: "0 2px",
      color: "#959699",
      fontSize: "18px",
    },
    total: {
      color: "#959699",
      fontSize: "18px",
    },
    page: {
      fontFamily: "Open Sans, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "30px",
      position: "relative",
      backgroundColor: "#ffffff",
      width: "375px",
      height: "812px",
      overflow: "hidden",
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
      height: "160px",
      width: "90%",
      borderBottom: "1px solid #E7E7E7",
    },
    title: {
      fontSize: "18px",
      marginBottom: "20px",
      color: "#333",
    },
    checkboxContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      width: "90%",
      marginBottom: "40px",
    },
    checkbox: {
      marginTop: "4px",
      transform: "scale(1.2)",
      accentColor: "#0052cc",
    },
    label: {
      fontSize: "14px",
      color: "#555",
      // textAlign: "justify",
      lineHeight: "1.5",
    },
    button: {
      width: "90%",
      padding: "12px",
      height: "54px",
      backgroundColor: colors.primario,
      color: "#fff",
      fontSize: "16px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      position: "absolute",
      bottom: 16,
    },
  };

  return (
    <div style={styles.telefono}>
      <div style={styles.page}>
        <div style={styles.header}>
          <div style={{ display: "flex", gap: 12 }}>
            {colors.url_logo !== "" ? (
                <img className="inicio-de-sesion-de-2" src={colors.url_logo}
                     style={{height: 70, maxWidth: 120, objectFit:'contain'}}/>) : (<></>)}
          </div>
          <div style={styles.containerStep}>
            <span style={styles.current}>01</span>
            <span style={styles.separator}> / </span>
            <span style={styles.total}>06</span>
          </div>
        </div>
        <div
          style={{
            ...styles.container,
            width: "100%",
            flexDirection: "column",
            justifyContent: "initial",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              justifyItems: "center",
              placeItems: "center",
            }}
          >
            <div style={{ width: "90%" }}>
              <h3 style={styles.title}>
                Accept some disclosures below to finish your application.
              </h3>
            </div>
            <div style={styles.checkboxContainer}>
              <input
                type="checkbox"
                checked={checked}
                onChange={handleCheckboxChange}
                style={styles.checkbox}
              />
              <label style={styles.label}>
                I have read, understand, and consent to the language and
                authorizations outlined in the Account Disclosures above. You
                are also signing the consent for SSA to disclose your SSN
                Verification to Pinnacle, and its affiliates. You agree that
                your electronic signature has the same legal meaning, validity,
                and effect as your handwritten signature.
              </label>
            </div>
          </div>
          <button onClick={handleButtonClick} style={styles.button}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
